import { render, staticRenderFns } from "./ShopSuccess.vue?vue&type=template&id=35ae4672&scoped=true&"
import script from "./ShopSuccess.vue?vue&type=script&lang=js&"
export * from "./ShopSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ShopSuccess.vue?vue&type=style&index=0&id=35ae4672&lang=scss&scoped=true&"
import style1 from "./ShopSuccess.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ae4672",
  null
  
)

export default component.exports